import { Component, OnInit } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument  } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import {User, WorkPeriod, WorkDay, Time} from 'src/interfaces';
import {FormGroup, FormControl} from '@angular/forms';
import { take } from 'rxjs/operators';

interface Position {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})

export class AdminComponent implements OnInit {
  private getOnce<T>(obs: Observable<T>): Promise<T> {
    return obs.pipe(take(1)).toPromise();
  }  

  weekday = ["Dimanche","Lundi","Mardi","Mercredi","Jeudi","Vendredi","Samedi"];
  positions = ["Employés de champ-Aux Fruits des Champs", "Employés de champ-Potager Eardley", "Employés du kiosque-Potager Eardley", "Autres employés-Potager Eardley", "Administrateur", 'Inactif'];
  positionRef = ["ChampsAFC", "ChampsPe", "Kiosque", "Autres", "Administration", "Inactif"];

  selectedPosition: string;
  prettyPosition: string;

  workDayCollection: AngularFirestoreCollection<WorkDay>;
  range = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });
  private userCollection: AngularFirestoreCollection<User>;
  userList$: Observable<User[]>;
  userList: User[] = [];
  filteredUserList: User[] = [];
  maxDate: Date;
//To add more position, add checkbox in ui, add lists here as well as bool
  champsAFCFilterList: User[] = [];
  champsPEFilterList: User[] = [];
  kioskFilterList: User[] = [];
  autresFilterList:User[] = [];
  adminFilterList: User[] = [];
  inactifFilterList: User[] = [];

  champsAFCFilter: boolean = false;
  champsPEFilter: boolean = false;
  autresFilter: boolean = false;
  kioskFilter: boolean = false;
  adminFilter: boolean = false;
  inactifFilter: boolean = false;

  newUser: boolean = false;
  updateUser: boolean = false;
  admin: boolean = false;

  fname: string;
  lname: string;
  position: string;
  pin: string;

  selectedUser: number;
  newPosition:string;

  errorFlag = false;
  errorMessage = '';
  
  constructor(
    private firestore: AngularFirestore,
  ) {
  }

  sales;
  data;

  isDumping = false;
  dumpProgress = { current: 0, total: 0 };


  ngOnInit() {
    this.setUsers();
    this.calculateDates();
  }
  createUser(){
    console.log("create user")

    const info = {

      id: this.fname.trim() + "." + this.lname.trim(),
      isAdmin: this.admin,
      name: this.fname.trim() + " " + this.lname.trim(),
      pin: this.pin.replace(/\s/g, ""),
      position: this.position
    }

    this.firestore.collection('Users/').doc(info.id).set(info);
    this.firestore.collection('Users/').doc(info.id).collection('Days').doc("initialize").set(info)

  }
  updateUserDoc(){
    console.log("Update User");
    console.log(this.selectedUser);
    console.log(this.userList[this.selectedUser])
    console.log(this.newPosition);

    var newU: any = {
      ... this.userList[this.selectedUser],
      position: this.newPosition
    }
    console.log(newU);

    let eventDoc = this.firestore.doc<User>('Users/'+newU.id);
    eventDoc.set(newU);
  }

  calculateDates(){
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getUTCMonth();
    const currentDay = new Date().getDate();
    this.maxDate = new Date(currentYear, currentMonth, currentDay);
  }

  getFilteredUsers() {
    //to add positions, add more entries to this nice if statement
    //positions = ["Employés de champ-Aux Fruits des Champs", "Employés de champ-Potager Eardley", "Employés du kiosque-Potager Eardley", "Autres employés-Potager Eardley", "Administrateur"];
    //positionRef = ["ChampsAFC", "ChampsPe", "Kiosque", "Autres", "Inactif", "Administration"];
    if(!this.userList$){
      return [];
    } else {
      if(this.kioskFilter && this.champsAFCFilter){
        return [];
      } else if(this.kioskFilter){
        this.prettyPosition = this.positions[2];
        this.selectedPosition = this.positionRef[2];
        return this.kioskFilterList;
        
      } else if(this.champsAFCFilter){
        this.prettyPosition = this.positions[0];
        this.selectedPosition = this.positionRef[0];
        return this.champsAFCFilterList;
      }else if(this.adminFilter){
        this.prettyPosition = this.positions[4];
        this.selectedPosition = this.positionRef[4];
        return this.adminFilterList;
      }else if(this.champsPEFilter){
        this.prettyPosition = this.positions[1];
        this.selectedPosition = this.positionRef[1];
        return this.champsPEFilterList;
      }else if(this.autresFilter){
        this.prettyPosition = this.positions[3];
        this.selectedPosition = this.positionRef[3];
        return this.autresFilterList;
      }else if(this.inactifFilter){
        this.prettyPosition = this.positions[5];
        this.selectedPosition = this.positionRef[5];
        return this.inactifFilterList;
      } else {
        this.selectedPosition = "Total-Employee";
        this.prettyPosition = "Tout les employees";
        return this.userList;
        
      }
    }
  }

  setUsers(){
    this.userCollection = this.firestore.collection<User>('Users');
    this.userList$ = this.userCollection.valueChanges();
    this.userList$.forEach(u => {
      this.userList = u;
      this.filteredUserList = u;
      //to add positions, copy paste this line with the new position name
      this.kioskFilterList = this.userList.filter(u => u.position == 'kiosque');
      this.champsAFCFilterList = this.userList.filter(u => u.position == 'champs-afc');
      this.champsPEFilterList = this.userList.filter(u => u.position == 'champs-pe');
      this.autresFilterList = this.userList.filter(u => u.position == 'autres');
      this.adminFilterList = this.userList.filter(u => u.position == 'admin');
      this.inactifFilterList = this.userList.filter(u => u.position == 'inactif');
    });
  }

  timeDiff(start: Time, end: Time) : Time{
    const minDiff = (end.hour*60 + end.minute) - (start.hour*60 + start.minute);
    return {hour: Math.floor(minDiff/60), minute: (minDiff%60)};
  }

  addTime(sum: Time, t: Time) {
    var min = (sum.hour*60 + sum.minute) + (t.hour*60 + t.minute);
    return {hour: Math.floor(min/60), minute: (min%60)};
  }
  private toYmdDots(d: Date): string {
    return `${d.getFullYear()}.${('0' + (d.getMonth() + 1)).slice(-2)}.${('0' + d.getDate()).slice(-2)}`;
  }
  
  private toYmdHyphen(ymdDots: string): string {
    // "2026.01.21" -> "2026-01-21"
    return ymdDots.split('.').join('-');
  }
  
  private dayOfWeekFrFromYmdDots(ymdDots: string): string {
    const [y, m, d] = ymdDots.split('.').map(n => parseInt(n, 10));
    const dt = new Date(y, (m - 1), d);
    const days = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];
    return days[dt.getDay()];
  }
  
  private durationHours(start: any, end: any): number {
    if (!start || !end) return 0;
  
    const s = (start.hour ?? 0) * 3600 + (start.minute ?? 0) * 60 + (start.second ?? 0);
    const e = (end.hour ?? 0) * 3600 + (end.minute ?? 0) * 60 + (end.second ?? 0);
  
    const diff = Math.max(0, e - s);
    return diff / 3600;
  }
  
  private parseTaskFields(descRaw: any): { taskNumber: string; category: string; description: string } {
    const s = (descRaw ?? '').toString().trim();
    if (!s) return { taskNumber: '', category: '', description: '' };
  
    // Format A: "81-Otro trabajo"
    // Format B: "84-Otro trabajo - Fertilization"
    // We will:
    // 1) split on first "-" (taskNumber vs rest)
    // 2) split the rest on " - " (or fallback to last "-") for optional description
  
    const firstDashIdx = s.indexOf('-');
    if (firstDashIdx === -1) {
      return { taskNumber: '', category: '', description: s };
    }
  
    const left = s.slice(0, firstDashIdx).trim();
    const rest = s.slice(firstDashIdx + 1).trim();
  
    const taskNumber = /^\d+$/.test(left) ? left : '';
    let category = '';
    let description = '';
  
    // Preferred separator between category and description
    const parts = rest.split(' - ');
    if (parts.length >= 2) {
      category = parts[0].trim();
      description = parts.slice(1).join(' - ').trim();
      return { taskNumber, category, description };
    }
  
    // If no " - " present, the whole rest is category (Format A)
    // But sometimes users may type "Otro trabajo-Fertilization" without spaces.
    // Try a last-dash heuristic ONLY if it looks like it has 2 concepts.
    const lastDashIdx = rest.lastIndexOf('-');
    if (lastDashIdx > 0) {
      const maybeCat = rest.slice(0, lastDashIdx).trim();
      const maybeDesc = rest.slice(lastDashIdx + 1).trim();
  
      // Only accept this split if both sides are non-empty and it doesn't look like a normal category with dashes
      if (maybeCat && maybeDesc) {
        category = maybeCat;
        description = maybeDesc;
        return { taskNumber, category, description };
      }
    }
  
    category = rest;
    description = '';
    return { taskNumber, category, description };
  }
  
  
  async exportDataDumpExcel(): Promise<void> {
    if (!this.range?.value?.start || !this.range?.value?.end) return;
  
    this.isDumping = true;
    this.dumpProgress = { current: 0, total: 0 };
  
    try {
      const startDate: Date = this.range.value.start;
      const endDate: Date = this.range.value.end;
  
      const start = this.toYmdDots(startDate);
      const end = this.toYmdDots(endDate);
  
      // 1) fetch all users
      const usersSnap: any = await this.getOnce(this.firestore.collection<User>('Users').get());
      const userDocs = usersSnap.docs;
      this.dumpProgress.total = userDocs.length;
  
      const rows: Array<{
        'Date': string;
        'Day of Week': string;
        'Name': string;
        'Position': string;
        'Hours': number;
        'Task Number': string;
        'Category': string;
        'Description': string;
      }> = [];
  
      // 2) for each user, fetch all days in range
      for (const uDoc of userDocs) {
        const userId = uDoc.id;
        const userData: any = uDoc.data();
        const name = userData?.name ?? userId;
        const position = userData?.position ?? '';

  
        const daysQuery = this.firestore.collection(`Users/${userId}/Days`, ref =>
          ref
            .where('date', '>=', start)
            .where('date', '<=', end)
            .orderBy('date', 'asc')
        );
  
        const daysSnap: any = await this.getOnce(daysQuery.get());
  
        for (const d of daysSnap.docs) {
          const day: any = d.data();
          const dateDots: string = day.date; // "YYYY.MM.DD"
          const dateHyphen = this.toYmdHyphen(dateDots);
          const dowFr = this.dayOfWeekFrFromYmdDots(dateDots);
  
          // workPeriod is a JSON string in your DB
          let periods: any[] = [];
          if (typeof day.workPeriod === 'string' && day.workPeriod.trim()) {
            try {
              periods = JSON.parse(day.workPeriod);
            } catch {
              periods = [];
            }
          }
  
          // If no periods but you still want a row per day, you could add a blank row here.
          for (const p of periods) {
            const hours = this.durationHours(p?.start, p?.end);
            const parsed = this.parseTaskFields(p?.description);
  
            rows.push({
              'Date': dateHyphen,
              'Day of Week': dowFr,
              'Name': name,
              'Position': position,
              'Hours': Math.round(hours * 100) / 100, // 2 decimals
              'Task Number': parsed.taskNumber,
              'Category': parsed.category,
              'Description': parsed.description,
            });
          }
        }
  
        this.dumpProgress.current += 1;
      }
  
      // 3) build workbook (single sheet)
      const headers = ['Date', 'Day of Week', 'Name', 'Position', 'Hours', 'Task Number', 'Category', 'Description'];
  
      import("xlsx").then(xlsx => {
        const ws = xlsx.utils.json_to_sheet(rows, { header: headers });
        const wb = xlsx.utils.book_new();
        xlsx.utils.book_append_sheet(wb, ws, 'Dump');
      
        const excelBuffer: any = xlsx.write(wb, { bookType: 'xlsx', type: 'array' });
      
        // uses your existing helper at the bottom of the file
        const startHyphen = start.split('.').join('-');
        const endHyphen = end.split('.').join('-');
        const fileNameBase = `timesheet_dump_${startHyphen}_to_${endHyphen}`;

        this.saveAsExcelFile(excelBuffer, fileNameBase);
      });
      
    } catch (err) {
      console.error('exportDataDumpExcel() failed:', err);
    } finally {
      this.isDumping = false;
    }
  }
  

  exportExcel(type: string) {
    console.log('exportExcel() called with type:', type);
  
    if (!this.range || !this.range.value || !this.range.value.start || !this.range.value.end) {
      console.error('exportExcel() – invalid date range:', this.range?.value);
      return;
    }
  
    const startDate: Date = this.range.value.start;
    const endDate: Date = this.range.value.end;
  
    const start = startDate.getFullYear() + '.' +
      ('0' + (startDate.getMonth() + 1)).slice(-2) + '.' +
      ('0' + startDate.getDate()).slice(-2);
  
    const end = endDate.getFullYear() + '.' +
      ('0' + (endDate.getMonth() + 1)).slice(-2) + '.' +
      ('0' + endDate.getDate()).slice(-2);
  
    console.log('[exportExcel] Start string:', start);
    console.log('[exportExcel] End string  :', end);
  
    const diffInMs = endDate.getTime() - startDate.getTime();
    const diffInDaysRaw = diffInMs / (1000 * 60 * 60 * 24);
    const diffInDays = 2 + diffInDaysRaw;
    const limitNumber = Math.max(1, Math.ceil(diffInDays) + 2);
  
    console.log('[exportExcel] diffInMs:', diffInMs);
    console.log('[exportExcel] diffInDaysRaw:', diffInDaysRaw);
    console.log('[exportExcel] diffInDays (with +2):', diffInDays);
    console.log('[exportExcel] limitNumber for query:', limitNumber);
  
    const users = this.getFilteredUsers() || [];
    console.log('[exportExcel] Filtered users count:', users.length, users);
  
    if (!users.length) {
      console.warn('[exportExcel] No filtered users, nothing to export.');
      return;
    }
  
    const globalData: any[] = [];
    let pendingQueries = users.length;
  
    console.log('[exportExcel] Starting Firestore queries. pendingQueries =', pendingQueries);
  
    for (const u of users) {
      const refPath = `Users/${u.id}/Days`;
      console.log('---');
      console.log('[exportExcel] Setting up query for user:', u.id, 'name:', u.name);
      console.log('[exportExcel] Collection path:', refPath);
  
      // NOTE: using `start` here instead of hard-coded '2025.11.01'
      this.workDayCollection = this.firestore.collection<WorkDay>(
        refPath,
        r => r
          .where('date', '>=', start)
          .orderBy('date', 'asc')
          .limit(limitNumber)
      );
  
      console.log('[exportExcel] Firestore query built for user:', u.id,
        'where date >=', start,
        'orderBy date asc',
        'limit', limitNumber
      );
  
      this.workDayCollection
        .valueChanges()
        .pipe(take(1))
        .subscribe({
          next: (workDays: WorkDay[]) => {
            console.log(`[exportExcel] valueChanges() next for user ${u.id}. workDays length:`, workDays.length);
            console.debug(`[exportExcel] Raw workDays for user ${u.id}:`, workDays);
  
            const userData: any[] = [];
  
            for (const wd of workDays) {
              console.debug(`[exportExcel] Evaluating wd for user ${u.id}:`, wd);
  
              if (wd.date >= start && wd.date <= end) {
                console.log(`[exportExcel] wd.date ${wd.date} is within [${start}, ${end}] for user ${u.id}`);
  
                const workDay = this.setWorkDay(wd);
                const [yyyy, mm, dd] = wd.date.split('.').map(Number);
                const dateObj = new Date(yyyy, mm - 1, dd);
  
                let temp: any = {
                  Name: u.name,
                  Date: workDay.date,
                  Day: this.weekday[dateObj.getDay()],
                  Notes: workDay.notes
                };
  
                console.debug('[exportExcel] Base row temp:', temp);
  
                const wps = workDay.workPeriods || [];
                let hourSum = { hour: 0, minute: 0 };
  
                wps.forEach((wp, index) => {
                  const startName = 'Start ' + (index + 1);
                  const endName = 'End ' + (index + 1);
                  const hoursName = 'Hours ' + (index + 1);
                  const descriptionName = 'Description ' + (index + 1);
  
                  const wpTotal = this.timeDiff(wp.start, wp.end);
                  hourSum = this.addTime(hourSum, wpTotal);
  
                  temp = {
                    ...temp,
                    [startName]: `${wp.start.hour}:${wp.start.minute}`,
                    [endName]: `${wp.end.hour}:${wp.end.minute}`,
                    [hoursName]: `${wpTotal.hour}:${wpTotal.minute}`,
                    [descriptionName]: wp.description
                  };
  
                  console.debug(`[exportExcel] Updated temp after wp index ${index}:`, temp);
                });
  
                // Fill empty slots up to 4 work periods
                for (let i = wps.length + 1; i <= 4; i++) {
                  const startName = 'Start ' + i;
                  const endName = 'End ' + i;
                  const hoursName = 'Hours ' + i;
                  const descriptionName = 'Description ' + i;
  
                  temp = {
                    ...temp,
                    [startName]: '',
                    [endName]: '',
                    [hoursName]: '',
                    [descriptionName]: ''
                  };
                }
  
                temp = {
                  ...temp,
                  TOTAL: `${hourSum.hour}:${hourSum.minute}`
                };
  
                console.log('[exportExcel] Final row for this wd & user', u.id, ':', temp);
  
                userData.push(temp);
                console.log(`[exportExcel] userData length for user ${u.id} now:`, userData.length);
              } else {
                console.debug(
                  `[exportExcel] wd.date ${wd.date} is OUTSIDE [${start}, ${end}] for user ${u.id}, skipping`
                );
              }
            }
  
            const sortedUserData = userData.sort((a, b) => {
              const keyA = a.Date;
              const keyB = b.Date;
              if (keyA < keyB) { return -1; }
              if (keyA > keyB) { return 1; }
              return 0;
            });
  
            console.log(`[exportExcel] sortedUserData length for user ${u.id}:`, sortedUserData.length);
            globalData.push(sortedUserData);
            console.log('[exportExcel] globalData length now:', globalData.length);
          },
          error: (err) => {
            console.error(`[exportExcel] Firestore query ERROR for user ${u.id}:`, err);
          },
          complete: () => {
            pendingQueries--;
            console.log(`[exportExcel] Query COMPLETE for user ${u.id}. pendingQueries =`, pendingQueries);
  
            // When all user queries have completed, generate the Excel once
            if (pendingQueries === 0) {
              console.log('[exportExcel] All Firestore queries completed. Final globalData:', globalData);
  
              switch (type) {
                case 'short':
                  console.log('[exportExcel] Creating SHORT Excel');
                  this.createShortExcel(globalData, users);
                  break;
  
                case 'admin':
                  console.log('[exportExcel] Creating ADMIN Excel');
                  this.createAdminExcel(globalData, users);
                  break;
  
                default:
                  console.log('[exportExcel] Creating DEFAULT Excel');
                  this.createExcel(globalData, users);
                  break;
              }
  
              console.log('[exportExcel] Excel generation done for type:', type);
            }
          }
        });
    }
  }
  

  createAdminExcel(globalData, users){
    console.log("Admin clicked");
    let worksheets = {};
    let SheetNames = [];
    let blank = [];
    
    setTimeout(()=>{
      import("xlsx").then(xlsx => {
        let workbook : any = { Sheets: {}, SheetsNames: []};
        // Iterates through users
        let sheet = xlsx.utils.aoa_to_sheet(blank)
        xlsx.utils.sheet_add_aoa(sheet, [[this.prettyPosition]]);

        for(const [index, d] of globalData.entries()){
          var total = 0;
          for(let s of globalData[index]){
            

            total += (Number(s.TOTAL.split(":")[0])*60);
            total += Number(s.TOTAL.split(":")[1]);
          }
          
          xlsx.utils.sheet_add_aoa(sheet, [[""]], {origin:-1});

          xlsx.utils.sheet_add_aoa(sheet, [["Nom",users[index].name]], {origin:-1});
          xlsx.utils.sheet_add_json(sheet, d, {origin:-1});
          xlsx.utils.sheet_add_aoa(sheet, [["Somme", total/60]], {origin:-1});


        }
        worksheets = { ... worksheets, [this.selectedPosition]: sheet};
        SheetNames = [... SheetNames, [this.selectedPosition]];

        workbook = { Sheets: worksheets, SheetNames: SheetNames }
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "Rapport ");
      });
    },1000);

  }
  

  createExcel(globalData, users){
    let worksheets = {};
    let SheetNames = [];
    setTimeout(()=>{
      import("xlsx").then(xlsx => {
        let workbook : any = { Sheets: {}, SheetsNames: []};
        // Iterates through users
        for(const [index, d] of globalData.entries()){
          let total : Time = {hour: 0, minute: 0};
          for(let d of globalData[index]){
            total = this.addTime(total, {hour: Number(d.TOTAL.split(":")[0]), minute: Number(d.TOTAL.split(":")[1])});
          }
          let name = users[index].name.substring(0,31);
          let sheet = xlsx.utils.json_to_sheet(d);
          xlsx.utils.sheet_add_aoa(sheet, [["Nom",users[index].name]], {origin:-1});
          xlsx.utils.sheet_add_aoa(sheet, [["Somme",total.hour+"."+total.minute]], {origin:-1});

          worksheets = { ... worksheets, [name]: sheet};
          SheetNames = [... SheetNames, [name]];
        }
        workbook = { Sheets: worksheets, SheetNames: SheetNames }
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "Rapport Long");
      });
    },1000);
  }
  exportShortExcel(type: string) {
    console.log('exportShortExcel() called with type:', type);
  
    if (!this.range || !this.range.value || !this.range.value.start || !this.range.value.end) {
      console.error('exportShortExcel() – invalid date range:', this.range?.value);
      return;
    }
  
    const startDate: Date = this.range.value.start;
    const endDate: Date = this.range.value.end;
  
    const start = startDate.getFullYear() + '.' +
      ('0' + (startDate.getMonth() + 1)).slice(-2) + '.' +
      ('0' + startDate.getDate()).slice(-2);
  
    const end = endDate.getFullYear() + '.' +
      ('0' + (endDate.getMonth() + 1)).slice(-2) + '.' +
      ('0' + endDate.getDate()).slice(-2);
  
    console.log('[exportShortExcel] Start string:', start);
    console.log('[exportShortExcel] End string  :', end);
  
    const getDaysArray = (s: Date, e: Date): Date[] => {
      console.log('[exportShortExcel] getDaysArray() from', s, 'to', e);
      const arr: Date[] = [];
      const dt = new Date(s);
      while (dt <= e) {
        arr.push(new Date(dt));
        dt.setDate(dt.getDate() + 1);
      }
      console.log('[exportShortExcel] getDaysArray() result length:', arr.length);
      return arr;
    };
  
    const diffInMs = endDate.getTime() - startDate.getTime();
    const diffInDaysRaw = diffInMs / (1000 * 60 * 60 * 24);
    const diffInDays = 2 + diffInDaysRaw;
    const limitNumber = Math.max(1, Math.ceil(diffInDays) + 2);
  
    console.log('[exportShortExcel] diffInMs:', diffInMs);
    console.log('[exportShortExcel] diffInDaysRaw:', diffInDaysRaw);
    console.log('[exportShortExcel] diffInDays (with +2):', diffInDays);
    console.log('[exportShortExcel] limitNumber for query:', limitNumber);
  
    const users = this.getFilteredUsers() || [];
    console.log('[exportShortExcel] Filtered users count:', users.length, users);
  
    if (!users.length) {
      console.warn('[exportShortExcel] No filtered users, nothing to export.');
      return;
    }
  
    const globalData: any[] = [];
    let pendingQueries = users.length;
  
    console.log('[exportShortExcel] Starting Firestore queries. pendingQueries =', pendingQueries);
  
    for (const u of users) {
      if (this.errorFlag) {
        console.warn('[exportShortExcel] errorFlag already true before starting user loop; aborting.', {
          errorMessage: this.errorMessage
        });
        return;
      }
  
      const refPath = `Users/${u.id}/Days`;
      console.log('---');
      console.log('[exportShortExcel] Setting up query for user:', u.id, 'name:', u.name);
      console.log('[exportShortExcel] Collection path:', refPath);
  
      this.workDayCollection = this.firestore.collection<WorkDay>(
        refPath,
        r => r
          .where('date', '>=', start)
          .orderBy('date', 'asc')
          .limit(limitNumber)
      );
  
      console.log('[exportShortExcel] Firestore query built for user:', u.id,
        'where date >=', start,
        'orderBy date asc',
        'limit', limitNumber
      );
  
      this.workDayCollection
        .valueChanges()
        .pipe(take(1))
        .subscribe({
          next: (workDays: WorkDay[]) => {
            console.log(`[exportShortExcel] valueChanges() next for user ${u.id}. workDays length:`, workDays.length);
            console.debug(`[exportShortExcel] Raw workDays for user ${u.id}:`, workDays);
  
            if (this.errorFlag) {
              console.warn('[exportShortExcel] errorFlag is true at start of next(); skipping user processing.', {
                userId: u.id,
                errorMessage: this.errorMessage
              });
              return;
            }
  
            const userData: any[] = [];
            const userDates: Date[] = [];
  
            for (const wd of workDays) {
              console.debug(`[exportShortExcel] Evaluating wd for user ${u.id}:`, wd);
  
              if (wd.date >= start && wd.date <= end) {
                console.log(`[exportShortExcel] wd.date ${wd.date} is within [${start}, ${end}] for user ${u.id}`);
  
                const workDay = this.setWorkDay(wd);
                const [yyyy, mm, dd] = wd.date.split('.').map(Number);
                const dateObj = new Date(yyyy, mm - 1, dd);
                userDates.push(dateObj);
  
                let temp: any = {
                  Date: workDay.date,
                  Jour: this.weekday[dateObj.getDay()]
                };
  
                const wps = workDay.workPeriods || [];
                let hourSum = { hour: 0, minute: 0 };
  
                for (const [index, wp] of wps.entries()) {
                  if (wp.start == null || wp.end == null) {
                    this.errorFlag = true;
                    this.errorMessage = 'Error with: ' + JSON.stringify(wd) + JSON.stringify(u);
                    console.error('[exportShortExcel] NULL start/end, setting errorFlag. Details:', {
                      workDay: wd,
                      user: u,
                      errorMessage: this.errorMessage
                    });
  
                    // Clear globalData to mirror original behavior
                    (globalData as any[]).length = 0;
                    return;
                  }
  
                  const startName = 'Debut ' + (index + 1);
                  const endName = 'Fin ' + (index + 1);
                  const hoursName = 'Heures ' + (index + 1);
  
                  const wpTotal = this.timeDiff(wp.start, wp.end);
                  hourSum = this.addTime(hourSum, wpTotal);
  
                  temp = {
                    ...temp,
                    [startName]: `${wp.start.hour}:${wp.start.minute}`,
                    [endName]: `${wp.end.hour}:${wp.end.minute}`,
                    [hoursName]: `${wpTotal.hour}:${wpTotal.minute}`
                  };
  
                  console.debug(`[exportShortExcel] Updated temp after wp index ${index}:`, temp);
                }
  
                // Fill empty slots up to 4 work periods
                const wpsCount = (workDay.workPeriods || []).length;
                for (let i = wpsCount + 1; i <= 4; i++) {
                  const startName = 'Debut ' + i;
                  const endName = 'Fin ' + i;
                  const hoursName = 'Heures ' + i;
  
                  temp = {
                    ...temp,
                    [startName]: '',
                    [endName]: '',
                    [hoursName]: ''
                  };
                }
  
                temp = {
                  ...temp,
                  TOTAL: `${hourSum.hour}:${hourSum.minute}`
                };
  
                console.log('[exportShortExcel] Final row for this wd & user', u.id, ':', temp);
                userData.push(temp);
                console.log(`[exportShortExcel] userData length for user ${u.id} now:`, userData.length);
              } else {
                console.debug(
                  `[exportShortExcel] wd.date ${wd.date} is OUTSIDE [${start}, ${end}] for user ${u.id}, skipping`
                );
              }
            }
  
            // Fill missing days with empty rows
            const datesForRange = getDaysArray(startDate, endDate);
  
            console.log(`[exportShortExcel] userDates length for user ${u.id}:`, userDates.length);
            console.log(`[exportShortExcel] datesForRange length:`, datesForRange.length);
  
            for (const usedDate of userDates) {
              for (let i = 0; i < datesForRange.length; i++) {
                if (usedDate.getTime() === datesForRange[i].getTime()) {
                  datesForRange.splice(i, 1);
                  break;
                }
              }
            }
  
            console.log(
              `[exportShortExcel] Remaining dates with no entries for user ${u.id}:`,
              datesForRange.length,
              datesForRange
            );
  
            for (const date of datesForRange) {
              let temp: any = {
                Date: date.getFullYear() + '.' +
                  ('0' + (date.getMonth() + 1)).slice(-2) + '.' +
                  ('0' + date.getDate()).slice(-2),
                Jour: this.weekday[date.getDay()]
              };
  
              for (let i = 1; i <= 4; i++) {
                const startName = 'Debut ' + i;
                const endName = 'Fin ' + i;
                const hoursName = 'Heures ' + i;
  
                temp = {
                  ...temp,
                  [startName]: '',
                  [endName]: '',
                  [hoursName]: ''
                };
              }
  
              temp = {
                ...temp,
                TOTAL: '0:0'
              };
  
              userData.push(temp);
            }
  
            const sortedUserData = userData.sort((a, b) => {
              const keyA = a.Date;
              const keyB = b.Date;
              if (keyA < keyB) { return -1; }
              if (keyA > keyB) { return 1; }
              return 0;
            });
  
            console.log(`[exportShortExcel] sortedUserData length for user ${u.id}:`, sortedUserData.length);
            globalData.push(sortedUserData);
            console.log('[exportShortExcel] globalData length now:', globalData.length);
          },
          error: (err) => {
            this.errorFlag = true;
            this.errorMessage = `Firestore query error for user ${u.id}: ${err?.message || err}`;
            console.error('[exportShortExcel] Firestore query ERROR for user', u.id, err);
          },
          complete: () => {
            pendingQueries--;
            console.log(`[exportShortExcel] Query COMPLETE for user ${u.id}. pendingQueries =`, pendingQueries);
  
            if (pendingQueries === 0) {
              console.log('[exportShortExcel] All Firestore queries completed. errorFlag =', this.errorFlag);
              console.log('[exportShortExcel] Final globalData:', globalData);
  
              if (this.errorFlag) {
                console.warn('[exportShortExcel] Aborting Excel creation due to errorFlag. errorMessage:', this.errorMessage);
                return;
              }
  
              switch (type) {
                case 'short':
                  console.log('[exportShortExcel] Creating SHORT Excel');
                  this.createShortExcel(globalData, users);
                  break;
  
                default:
                  console.log('[exportShortExcel] Creating DEFAULT Excel');
                  this.createExcel(globalData, users);
                  break;
              }
  
              console.log('[exportShortExcel] Excel generation done for type:', type);
            }
          }
        });
    }
  }
  

  createShortExcel(globalData, users){
    if(this.errorFlag){
      return
    }
    console.log("Short clicked");
    let worksheets = {};
    let SheetNames = [];
    let blank = [];
    
    setTimeout(()=>{
      import("xlsx").then(xlsx => {
        let workbook : any = { Sheets: {}, SheetsNames: []};
        // Iterates through users
        let sheet = xlsx.utils.aoa_to_sheet(blank)
        xlsx.utils.sheet_add_aoa(sheet, [[this.prettyPosition]]);

        for(const [index, d] of globalData.entries()){
          var total = 0;
          for(let s of globalData[index]){
            

            total += (Number(s.TOTAL.split(":")[0])*60);
            total += Number(s.TOTAL.split(":")[1]);
          }
          
          xlsx.utils.sheet_add_aoa(sheet, [[""]], {origin:-1});

          xlsx.utils.sheet_add_aoa(sheet, [["Nom",users[index].name]], {origin:-1});
          xlsx.utils.sheet_add_json(sheet, d, {origin:-1});
          xlsx.utils.sheet_add_aoa(sheet, [["Somme", total/60]], {origin:-1});


        }
        worksheets = { ... worksheets, [this.selectedPosition]: sheet};
        SheetNames = [... SheetNames, [this.selectedPosition]];

        workbook = { Sheets: worksheets, SheetNames: SheetNames }
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "Rapport ");
      });
    },1000);

  }

  // Saves File
  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      FileSaver.saveAs(
        data,
        fileName + this.prettyPosition +" " + (this.range.value.start.getFullYear()+"-"+("0" + (this.range.value.start.getMonth() + 1)).slice(-2)+"-"+("0" + this.range.value.start.getDate()).slice(-2)) + " au " + (this.range.value.end.getFullYear()+"-"+("0" + (this.range.value.end.getMonth() + 1)).slice(-2)+"-"+("0" + this.range.value.end.getDate()).slice(-2)) + EXCEL_EXTENSION
        //Rapport Aux Fruits des Champs Employes Champs 2022-05-10 > 2022-05-10.xlsx
      );
    });
  }

  rangeSelected(){
    return this.range.value.start && this.range.value.end
  }

  setWorkDay(wd): WorkDay{
    let temp : WorkPeriod[] = [];
    for(let wp of JSON.parse(wd.workPeriod)){
      temp.push(this.newWorkPeriod(wp.description, wp.start, wp.end));
    }
    return {
      "isWorking": wd.isWorking,
      "date": wd.date,
      "notes": wd.notes,
      "workPeriods": temp
    }
  }

  newWorkPeriod(description: string, start: Time, end: Time) : WorkPeriod{
    return {
      description,
      start,
      end
    }
  }
}
